"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigMissingException = void 0;
const domain_exception_1 = require("./domain.exception");
/**
 * Should be thrown when a piece of static configuration is needed but is not set
 *
 * For example:
 * - Attempting to sign a JWT but the secret value is not present.
 * - Database credentials not present
 */
class ConfigMissingException extends domain_exception_1.DomainException {
    constructor(message, data) {
        super(message, data);
    }
}
exports.ConfigMissingException = ConfigMissingException;
